import React from 'react';
import { FiClock } from 'react-icons/fi';

/** Quiet status line for an active custom range: same voice as the card subtitles, text action to reset. */
const HistoricalRangeBanner = ({ text, clearLabel, onClear }) => (
    <div role="status" className="flex flex-wrap items-center gap-x-3 gap-y-1 text-sm font-medium text-zinc-500 dark:text-slate-400">
        <span className="inline-flex items-center gap-1.5"><FiClock className="w-4 h-4 shrink-0" />{text}</span>
        <button type="button" onClick={onClear}
                className="underline underline-offset-4 decoration-slate-400/60 hover:text-slate-900 dark:hover:text-white transition-colors min-h-[32px] md:min-h-0">
            {clearLabel}
        </button>
    </div>
);

export default HistoricalRangeBanner;
